<template>
  <div id="app">
    <router-view/>
    <notifications group="notification" position="bottom center" width="100%"/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.vue-notification {
  font-size: 16px;
}
.vue-notification.success {
  background: #3c94a4;
  border-left-color: #42A85F;
}
.vue-notification.error {
  background: #B5390C;
  border-left-color: #B82E24;
}
</style>



// WEBPACK FOOTER //
// src/App.vue